const REVEAL_PADDING_PX = 8;

type VerticalBounds = Pick<DOMRect, 'top' | 'bottom'>;

export function getMinimalRevealScrollDelta(containerRect: VerticalBounds, targetRect: VerticalBounds, padding = REVEAL_PADDING_PX): number {
  const visibleTop = containerRect.top + padding;
  const visibleBottom = containerRect.bottom - padding;
  if (targetRect.top < visibleTop) return targetRect.top - visibleTop;
  if (targetRect.bottom > visibleBottom) return targetRect.bottom - visibleBottom;
  return 0;
}
